import Axios from 'axios';
import EndPoints from '../EndPoints';

export default class DownloadService {
	static download = files => {
		if (Array.isArray(files)) {
			return new Promise((resolve, reject) => {
				Axios.post(EndPoints.Download, files)
					.then(response => {
						resolve(response.data.location);
					})
					.catch(() => {
						reject(new Error('Download zip failed due to an unexpected error.'));
					});
			});
		}
		return undefined;
	}
}



// WEBPACK FOOTER //
// ./src/services/DownloadService.js